import { Module } from 'vuex-smart-module';
import AnalitycsListActions from './actions';
// import AnalitycsListGetters from './getters';
import AnalitycsListMutations from './mutations';
import AnalitycsListState from './state';

export default new Module({
  state: AnalitycsListState,
  mutations: AnalitycsListMutations,
  actions: AnalitycsListActions,
  // getters: AnalitycsListGetters,
});
